
<template>
  <div class="site" style="padding-top: 20px;">
    <!-- eslint-disable  -->
    <FirstCaseHead
      :siteName="siteName"
      :cancalChild="cancalChild"
      :isVideo="isVideo"
    ></FirstCaseHead>
    <div class="content">
      <div class="view">
        <iframe ref="iframe" id="bdIframe" :src="view.src" frameborder="0" hight="auto"></iframe>
      </div>
    </div>
    <div class="tipsPop" v-if="isOut">
      <div class="head">
        提示
        <div class="icon" @click="isOut=false">
          ×
        </div>
        <div class="co">
          <img src="../../assets/images/mark.png" alt />
        </div>
        <div class="cont">退出将保存当前模拟进度，下次进入时可继续模拟操作 </div>
        <div class="btnWrap">
          <div class="btn" @click="outCase()">退出</div>
          <div class="btnN" @click="isOut=false">取消</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FirstCaseHead from "../../components/FirstCaseHead/Index";
import CommonPop from "../../components/CommonPop/Index";
export default {
  name: "site",
  data: function() {
    return {
      isOut:false,
      siteName: " 初识亚马逊卖家后台 ",
      view: {
        src: "http://120.78.89.173/sellercentral_us//sellercentral.html"
      },
      isVideo: false,
      regInfo: {},

    };
  },
  beforeRouteLeave(to, from, next) {
    if (to.path == "/fbaExport") {
    } else {
      // this.closeVideo();
      this.$store.dispatch("loginState", { isshowVideo: false });
    }
    next();
  },
  mounted() {
  },
  computed: {
    user() {
      return this.$store.getters.user;
    }
  },
  watch: {},
  created() {
  },
  methods: {
    outCase(){
      this.goLinks('/caseDetail?id='+this.$route.query.id)
    },
    cancalChild(e) {
       if (e == "outCase") {
          this.isOut=true;
        }
      if (e == "video") {
         this.$axios
        .get(
          "http://127.0.0.1:17990/GET?Info=caseVideo&no=" + -1+'&case='+this.$route.query.case
        )
        .then(res => {
          let data = res.data;
        });
      }
    }
  },
  components: {
    FirstCaseHead,
    // eslint-disable-next-line vue/no-unused-components
    CommonPop
  }
};
</script>
<style lang="scss" scoped>
.colsPop {
  position: fixed;
  width: 430px;
  height: 625px;
  top: 85px;
  background: #ffffff;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.16);
  border-radius: 2px;
  box-sizing: border-box;
  padding: 0 24px 0 25px;
  left: 24px;
  z-index: 99999;
}

.colsCont {
  position: relative;
  .pinyin {
    position: absolute;
    left: 0px;
    bottom: -25px;
    border: 1px solid #f3cd70;
    font-size: 12px;
    height: 30px;
    border-radius: 21px;
    line-height: 30px;
    text-align: center;
    width: 90px;
    cursor: pointer;
  }
  .lv {
    background-color: #f3cd70;
  }
}
.colsCont .close {
  position: absolute;
  top: 10px;
  right: -17px;
  cursor: pointer;
  color: #232f3e;
}
.colsCont .close img {
  width: 13px;
  height: 13px;
}
.colsCont {
  .tab {
    display: flex;
    justify-content: space-between;
    padding: 32px 0;
    .tabs {
      height: 34px;
      line-height: 34px;
      font-size: 14px;
      cursor: pointer;
    }
    .tabs:hover {
      color: #178aff;
      border-bottom: 1px solid #178aff;
    }
    .avt {
      color: #178aff;
      border-bottom: 1px solid #178aff;
    }
  }
  .boxConts {
    height: 500px;
    overflow: auto;
    position: relative;
    .btn {
      position: absolute;
      bottom: 0;
      right: 0px;
      height: 30px;
      line-height: 29px;
      display: flex;
      font-size: 14px;
      align-items: center;
      padding: 4px 10px;
      border-radius: 5px;
      // background-color: #;
      border: 1px solid #e8e8e8;
      background-color: white;
      cursor: pointer;
      img {
        width: 25px;
        height: 25px;
        margin-right: 5px;
      }
    }
    .btn:hover {
      background-color: #f3cd70;
      border: 1px solid #f3cd70;
    }
    ul {
      .title{
            line-height: 36px;
            font-weight: bold;
      }
      li {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 20px;
        color: #000000;
        margin-bottom: 5px;
        .name {
          color: #666666;
        }
        .dev {
          font-weight: bold;
          margin-top: 10px;
          display: inline-block;
          color: #000;
        }
        span {
          color: #ff0000;
        }
      }
      .list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        img {
          width: 100px;
          height: 100px;
          margin-bottom: 15px;
        }
      }
    }
  }
}

.pyPop {
  height: 188px;
  left: auto;
  right: 0px;
  .close {
    top: 11px;
  }
  .head {
    height: 40px !important;
    line-height: 40px;
    .uname {
      padding-top: 0;
      font-size: 14px;
      line-height: 40px !important;
    }
  }
  .input_wrap {
    padding-top: 21px;
    .ipt {
      padding-bottom: 10px;
      display: flex;
      label {
        font-size: 14px;
        margin-left: 5px;
        width: 42px;
        height: 30px;
        line-height: 30px;
      }
      input {
        width: 283px;
        height: 30px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(232, 232, 232, 1);
        opacity: 1;
        border-radius: 4px;
        outline: none;
        box-sizing: border-box;
        padding-left: 10px;
      }
    }
  }
  .iBtn {
    width: 68px;
    height: 20px;
    background: rgba(243, 205, 112, 1);
    opacity: 1;
    border-radius: 4px;
    text-align: center;
    position: absolute;
    font-size: 12px;
    line-height: 20px;
    right: 0px;
    bottom: -37px;
    cursor: pointer;
  }
}
.view {
  height: calc(100vh - 80px);
  margin: 0 auto;
}
.view iframe {
  height: 100%;
  width: 100%;
}
.Home {
  background-color: #ffffff;
}
.content {
  // max-width: 1380px;
  // padding-top:10px ;
  margin: 0 auto;
  box-sizing: border-box;
}
.siteWrap {
  display: flex;
}
.siteWrap .siteUl {
  display: flex;
  flex-wrap: wrap;
}
.siteWrap .siteUl .siteLi {
  margin-right: 20px;
  margin-bottom: 20px;
}
.siteWrap .siteUl .siteLi:nth-child(5n-0) {
  margin-right: 0px;
}
.siteWrap .siteUl .siteLi .icon {
  background-color: #232f3e;
  height: 128px;
}
.siteWrap .siteUl .siteLi .icon img {
  width: 96px;
  height: 96px;
  padding: 26px 82px 0 82px;
}
.siteWrap .siteUl .siteLi .name {
  color: #ffffff;
  background-color: #2f3a48;
  text-align: center;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
}
// 评分弹窗
.pop_bg {
  width: 100%;
  left: 0px;
  top: 0px;
  height: 100%;
  position: fixed;
  /*    user-select: none; */
  z-index: 99;
  background-color: #000;
  opacity: 0.5;
}
.scorePop {
  position: fixed;
  left: 50%;
  top: 50%;
  z-index: 999;
  background-color: #fff;
  transform: translate(-50%, -50%);
  width: 1180px;
  height: 500px;
  box-sizing: border-box;
  padding: 0 23px 0 23px;
  .head {
    display: flex;
    position: relative;
    .el {
      display: flex;
      padding-top: 19px;
      .li {
        width: 77px;
        height: 77px;
        border: 1px solid #d6d6d6;
        background-color: #fff;
        border-radius: 50%;
        box-sizing: border-box;
        .num {
          width: 40px;
          height: 30px;
          font-size: 22px;
          font-family: PingFang SC;
          font-weight: bold;
          line-height: 30px;
          color: #000000;
          text-align: center;
          margin: 12px auto 0;
          border-bottom: 1px solid #d6d6d6;
        }
        .nx {
          font-size: 12px;
          line-height: 17px;
          color: #232f3e;
          text-align: center;
          line-height: 17px;
          margin-top: 6px;
        }
      }
      .avt {
        margin-right: 17px;
        background-color: #f3cd70;
        border: 1px solid #f3cd70;
        .num {
          border-bottom: 1px solid #000000;
        }
      }
    }
    .ps {
      width: 444px;
      height: 17px;
      font-size: 12px;
      font-weight: 400;
      line-height: 17px;
      color: #ff0000;
      margin-left: 17px;
      margin-top: 68px;
    }
    .btnScore {
      position: absolute;
      right: 24px;
      top: 46px;
      width: 110px;
      height: 32px;
      background: #f3cd70;
      line-height: 32px;
      border-radius: 4px;
      color: #232f3e;
      font-size: 14px;
      text-align: center;
      cursor: pointer;
    }
    .close {
      position: absolute;
      top: 10px;
      right: 5px;
      cursor: pointer;
      img {
        width: 16px;
        height: 16px;
      }
    }
  }
  .cont {
    margin-top: 10px;
    max-height: 358px;
    overflow-y: scroll;
    .titUl {
      display: flex;
      .li {
        flex: 1;
        border: 1px solid #e1e1e2;
        padding-left: 12px;
        height: 50px;
        line-height: 23px;
        align-items: center;
        color: #000000;
        display: flex;
        font-size: 14px;
        background-color: #ebebeb;
        border-right: 0;
      }
      .li:last-of-type {
        border-right: 1px solid #e1e1e2;
      }
      .fx4 {
        flex: 4;
      }
    }
    .conList {
      .titUl {
        .li {
          font-size: 12px;
          background-color: #f5f5f5;
          display: flex;
          align-items: center;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          padding-top: 15px;
        }
        .dP {
          img {
            width: 20px;
            margin-right: 10px;
            vertical-align: middle;
            margin-top: -3px;
          }
        }
      }
      .titUl:nth-child(odd) {
        .li {
          border-top: 0;
          border-bottom: 0;
          background-color: #fff;
        }
      }
      .titUl:last-of-type {
        border-bottom: 1px solid #e1e1e2;
        .li {
          border-bottom: 0;
        }
      }
      .avt {
        .li {
          color: #ff0000;
        }
      }
    }
  }
}
.selectPop {
  position: fixed;
  left: 50%;
  top: 50%;
  z-index: 9999;
  background-color: #fff;
  transform: translate(-50%, -50%);
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.16);
  width: 400px;
  height: 200px;
  border-radius: 2px;
  box-sizing: border-box;
  padding: 0 25px;
  .title {
    border-bottom: 1px solid #e8e8e8;
    height: 81px;
    line-height: 81px;
    font-size: 18px;
    color: #000;
    text-align: center;
    position: relative;
    .close {
      position: absolute;
      top: -13px;
      right: 0px;
      cursor: pointer;
      img {
        width: 16px;
        height: 16px;
      }
    }
  }
  .btn {
    width: 120px;
    height: 40px;
    text-align: center;
    background: rgba(243, 205, 112, 1);
    opacity: 1;
    border-radius: 21px;
    font-size: 14px;
    color: rgba(35, 47, 62, 1);
    line-height: 40px;
    margin: 47px auto 0;
    cursor: pointer;
  }
}
.tipsPop {
  width: 400px;
  height: 235px;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.16);
  border-radius: 2px;
  position: fixed;
  left: 50%;
  top: 50%;
  z-index: 9999;
  background-color: #fff;
  transform: translate(-50%, -50%);
  box-sizing: border-box;
  padding: 0 32px 0 34px;
  .head {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border-bottom: 1px solid #e8e8e8;
    color: #000000;
    position: relative;
    .icon {
      position: absolute;
      right: -10px;
      top: 0px;
      cursor: pointer;
      img {
        width: 10px;
        height: 10px;
      }
    }
  }
  .co {
    width: 322px;
    line-height: 20px;
    font-size: 12px;
    margin-top: 12px;
    text-align: center;
  }
  .cont {
    text-align: center;
    line-height: 20px;
    font-size: 12px;
    margin: 0 auto;
    width: 300px;
    padding-top: 25px;
  }
  .btnWrap {
    text-align: center;
    margin-top: 34px;
    .btn {
      width: 110px;
      height: 32px;
      border-radius: 4px;
      background-color: #f3cd70;
      color: #232f3e;
      font-size: 12px;
      display: inline-block;
      line-height: 32px;
      cursor: pointer;
      box-sizing: border-box;
      vertical-align: middle;
    }
    .btnN {
      width: 110px;
      height: 32px;
      border-radius: 4px;
      background-color: #ffffff;
      border: 1px solid rgba(243, 205, 112, 1);
      box-sizing: border-box;
      color: #57616c;
      font-size: 12px;
      display: inline-block;
      line-height: 32px;
      cursor: pointer;
      margin-left: 10px;
      vertical-align: middle;
    }
  }
}
</style>
<style >
.Home .el-carousel__container {
  height: 580px;
}
</style>